var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal-target',_vm._b({},'portal-target',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }